/**
 * @generated SignedSource<<bd77e962635b2d43fa66e3fb576a5ad0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type StreamAccessType = "full" | "partial" | "shared";
export type MergeStreamPreviewQuery$variables = {
  destinationStreamId: string;
  sourceStreamId: string;
};
export type MergeStreamPreviewQuery$data = {
  readonly destinationStream: {
    readonly displayName: string;
    readonly id: string;
    readonly notestreamusers: ReadonlyArray<{
      readonly accessType: StreamAccessType;
      readonly id: string;
      readonly user: {
        readonly fullName: string;
        readonly id: string;
        readonly isGuest: boolean;
      };
    }>;
  } | null;
  readonly sourceStream: {
    readonly displayName: string;
    readonly id: string;
    readonly notes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly createdAt: string | null;
          readonly eventEnd: string | null;
          readonly eventStart: string | null;
          readonly id: string;
          readonly noteType: NoteStreamType;
          readonly rawDraftJson: any;
        } | null;
      } | null>;
    } | null;
    readonly notesCount: number;
    readonly notestreamusers: ReadonlyArray<{
      readonly accessType: StreamAccessType;
      readonly id: string;
      readonly user: {
        readonly fullName: string;
        readonly id: string;
        readonly isGuest: boolean;
      };
    }>;
    readonly type: NoteStreamType;
  } | null;
};
export type MergeStreamPreviewQuery = {
  response: MergeStreamPreviewQuery$data;
  variables: MergeStreamPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationStreamId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceStreamId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamUser",
  "kind": "LinkedField",
  "name": "notestreamusers",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accessType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": "sourceStream",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "sourceStreamId"
      }
    ],
    "concreteType": "NoteStream",
    "kind": "LinkedField",
    "name": "noteStream",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "notesCount",
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "NotesConnection",
        "kind": "LinkedField",
        "name": "notes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rawDraftJson",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noteType",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": "destinationStream",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "destinationStreamId"
      }
    ],
    "concreteType": "NoteStream",
    "kind": "LinkedField",
    "name": "noteStream",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MergeStreamPreviewQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MergeStreamPreviewQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "d4189b9930b483d86eff83973289405b",
    "id": null,
    "metadata": {},
    "name": "MergeStreamPreviewQuery",
    "operationKind": "query",
    "text": "query MergeStreamPreviewQuery(\n  $sourceStreamId: ID!\n  $destinationStreamId: ID!\n) {\n  sourceStream: noteStream(id: $sourceStreamId) {\n    id\n    type\n    displayName\n    notesCount\n    notestreamusers {\n      id\n      accessType\n      user {\n        id\n        fullName\n        isGuest\n      }\n    }\n    notes {\n      edges {\n        node {\n          id\n          rawDraftJson\n          createdAt\n          eventStart\n          eventEnd\n          noteType\n        }\n      }\n    }\n  }\n  destinationStream: noteStream(id: $destinationStreamId) {\n    id\n    displayName\n    notestreamusers {\n      id\n      accessType\n      user {\n        id\n        fullName\n        isGuest\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf47088965edf64baba341b26c90c8e7";

export default node;
